import { useState } from "react";
import { showToast } from "../../utils/toastUtils";

interface UseCancelProps {
  onCancel: () => Promise<void>;
}

const useCancel = ({ onCancel }: UseCancelProps) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const handleCancel = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      setIsProcessing(true);
      await onCancel();
      showToast("Invoice canceled successfully!", "success")
    } catch (error: any) {
      showToast( error.message || "An error occurred while canceling the invoice.", "error")
    } finally {
      setIsProcessing(false);
    }
  };

  return { isProcessing, handleCancel };
};

export default useCancel;
